import { Game } from './game/Game.js';
import { isDevGlobalEnabled } from './debug/debugLog.js';

const canvas = document.querySelector('#game-canvas');
if (!(canvas instanceof HTMLCanvasElement)) {
  throw new Error('Game canvas element not found.');
}

const game = new Game({ canvas });
game.start();

if (isDevGlobalEnabled()) {
  globalThis.__matrixGame = game;
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    game.dispose();
  });
}
